
import ImageCarussel from '../Image-Carussel/ImageCarussel'
import '../Welcome/WelcomePage.css';
import { Helmet } from 'react-helmet-async';


function WelcomeAbout() {


    return (
        <>
            <Helmet>
                <title>Über mich</title>
                <meta name="description" content='
                 Nach meinem Studium der Ernährungs- und Haushaltstechnik arbeitete ich in der Industrie, bevor ich 1995 meine Praxis für Ernährungsberatung in Püttlingen gründete. 
                 Als zertifizierte Diät- und Ernährungsberaterin sowie Ernährungsfachkraft Allergologie bringe ich langjährige Erfahrung in Einzel- und Gruppenberatungen mit. Ich arbeite 
                 mit allen gesetzlichen und privaten Krankenkassen zusammen und biete seit 2020 auch Online Ernährungsberatung per Zoom, Skype und WhatsApp-Video-Chat. 
                 Als erfahrene Seminarleiterin und Dozentin biete ich auch Seminare, Vorträge, Kochkurse und betriebliche Gesundheitsförderung an.' />
            </Helmet>
            <div className="WelcomePage">
                <div className='CompletePage'>
                    <div className="WelcomePagePictures">
                        <ImageCarussel />

                    </div>

                    <div className='WelcomePageContent'>


                        <p className='Text'>
                            <br></br><br></br>
                            Nach dem Abitur 1985 studierte ich Ernährungs- und Haushaltstechnik an der Fachhochschule Rheinland-Pfalz , 
                            Abteilung Trier und beendete das Studium 1989 als Diplom-Ingenieurin (FH). Es folgte eine mehrjährige Industrietätigkeit in einem
                            Tochterunternehmen der Südzucker AG wo ich nach einem Traineeprogramm im Bereich Produktion und Technik zunächst als Assistentin der 
                            Werksleitung und schließlich als Abteilungsleiterin Produktentwicklung tätig war. Nach kurzer Familienpause führe ich seit 1995 meine Praxis für 
                            Ernährungsberatung und Ernährungstherapie in Püttlingen. Seit 2004 bin ich als qualifizierte Diät- und Ernährungsberaterin über den Verband für 
                            Ernährung und Medizin in Aachen (VFED) zertifiziert und seit 2013 als Ernährungsfachkraft Allergologie über den Deutschen Allergie- und Asthmabund (DAAB).
                            Darüber hinaus finden Sie mein Profil im VDOe Expertenpool (Verband der Oecotrophologen). 2009 erwarb ich die Zusatzqualifikation NLP-Practitioner. Bis heute führte ich zahlreiche Einzel- und Gruppenberatungen in Theorie und Praxis durch, seit 2020 auch online, per Zoom, Skype,
                             WhatsApp-Video-Chat und telefonisch. Ich war viele Jahre lang für die Firma AMC in Bingen als Leiterin von Ernährungsseminaren 
                            sowie lange Jahre als Dozentin für verschiedene Volkshochschulen tätig, arbeite mit allen gesetzlichen 
                            und privaten Krankenkassen zusammen und werde gebucht für Seminare, Vorträge, Aktionstage, Kochkurse und die betriebliche Gesundheitsförderung.
                            <br></br><br></br>
                        </p>



                    </div>



                </div>




            </div>

        </>

    );
}

export default WelcomeAbout; 